// import React from 'react'
// import {Switch, Route, Redirect} from 'react-router-dom'
import Login from "../pages/login/Login";
import Pathology from "../pages/Pathology/Pathology";

import {
  ACTIONS,
  AuthRoutes,
  NonAuthRoutes,
  USERTYPES,
} from "../constants/Constants";
import AdminUserList from "../pages/AdminUser/AdminUserList";
import Modality from "../pages/Masters/Modality/Modality";
import ErrorStudy from "../pages/ErrorStudy/ErrorStudy";
// import AuditLog from '../pages/AuditLog/AuditLog';
import HospitalsList from "../pages/Hospital/HospitalsList";
import UserView from "../pages/User/UserView";
import ProviderList from "../pages/Provider/ProviderList";
import ClientList from "../pages/Client/ClientList";
import AnnotationList from "../pages/annotation/AnnotationList";
import AddAnnotation from "../pages/annotation/AddAnnotation";
import ViewAnnotation from "../pages/annotation/ViewAnnotation";
import SupervisorList from "../pages/Supervisor/SupervisorList";
import FirmAdminUserList from "../pages/AdminUser/FirmAdminUserList";
import FirmDoctorList from "../pages/Firm/FirmDoctor/FirmDoctorList";
import FirmTechnicianList from "../pages/Firm/FirmTechnician/FirmTechnicianList";
import RadiologistList from "../pages/Radiologist/RadiologistList";
import StudyList from "../pages/StudyList/StudyList";
import HeaderTemplates from "../pages/Templates/HeaderTemplates";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import FirmState from "../context/firms/FirmState";
import HPState from "../context/hanging-protocol/HPState";
import StudylistState from "../context/studylist/StudylistState";
import Viewer from "../pages/StudyViewer/Viewer";
import StudyviewerState from "../context/studyviewer/StudyViewerState";
import StudyReportState from "../context/studyreport/StudyReportState";
import ReportPanel from "../pages/Report/ReportPanel";
import ThumbnailState from "../context/studyviewer/ThumbnailState";
import ViewportState from "../context/studyviewer/ViewportState";
import AnnotationState from "../context/annotation/AnnotationState";
import UploadStudy from "../pages/StudyList/components/UploadStudy/UploadStudy";
// import ShareStudyState from '../context/ShareStudy/ShareStudyState';
import ShareStudyState from "../context/sharestudy/ShareStudyState";
import ViewProvider from "../pages/Provider/ViewProvider";
import ErrorCodeList from "../pages/Masters/ErrorCode/ErrorCodeList";
import MyAddUpdateUser from "../pages/User/MyAddUpdateUser";
import Firm from "../pages/Firm/Firm";
import AddReportTemplate from "../pages/ReportTemplates/AddReportTemplates/AddReportTemplate";
import AddStyle from "../pages/MyStyles/AddStyle/AddStyle";
import HeaderTemplate from "../pages/Masters/HeaderTemplate/HeaderTemplate";
import ACCOUNTANDSETTINGS from "../pages/AccountAndSettings/AccountAndSettings";
import Analytics from "../pages/Analytics/Analytics";
import { SharedReport } from "../pages/StudyList/components/Actions/SendReportEmail";
import { createBrowserRouter } from "react-router-dom";
import IssuesAndTroubleshooting from "../pages/IssuesAndTroubleshooting/IssuesAndTroubleshooting";
import About from "../pages/About/About";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import QRCodeScanReport from "../pages/StudyList/components/QRCodeScanReport";
import ForgotPassword from "../pages/login/ForgotPassword";
import Otp from "../pages/login/Otp";
import ResetPassword from "../pages/login/ResetPassword";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { isMobile } from "react-device-detect";
import AdvanceViewer from "../pages/StudyViewer/AdvanceViewer";
import Billing from "../pages/Billing/Billing";
import IssuesTroubleShooting from "../pages/IssuesAndTroubleshooting/IssuesTroubleShooting";
import ReportTemplateListv2 from "../pages/ReportTemplates/ReportTemplateListv2";
import MyStyles from "../pages/MyStyles/MyStyles";
import ProgressBarState from "../context/progressbar/ProgressBarState";
import Ping from "../components/Ping/Ping";
import SharedStudyViewer from "../pages/SharedViewer/SharedStudyViewer";
import TypistList from "../pages/Firm/Typist/TypistList";
import MobileViewerState from "../context/studyviewer/MobileViewerState";
import MobileMoreOption from "../pages/MobileMoreOption/MobileMoreOption";
import NotAuthorized from "../components/NotAuthorized";
import BillingDownloadDataForm from "../pages/Billing/BillingDownloadDataForm";
import OpenContextStudyList from "../pages/StudyList/OpenContextStudyList";
import SubModality from "../pages/Masters/SubModality/SubModality";
import PacsQueue from "../pages/PacsQueue/PacsQueue";
import DownloadTrigger from "../pages/DownloadTrigger/DownloadTrigger";
import { ThemeProvider } from "@fluentui/react";
import { lightTheme } from "../constants/Themes";
import TwoFAOtp from "../pages/login/TwoFAOtp";
import HPFormManager from "../pages/HangingProtocol/HPFormManager";
import HangingProtocolList from "../pages/HangingProtocol/HangingProtocolList";

import AdvLicense from "../pages/AdvLicence/AdvLicence";
import { QueryClient, QueryClientProvider } from "react-query";

const mobileStyles = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const desktopStyles = {
  height: "100%",
};

const queryClient = new QueryClient();

export const RouterConfig = createBrowserRouter([
  {
    path: NonAuthRoutes.ROOT,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <Login />
        </GoogleOAuthProvider>
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.LOGIN,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <Login />
        </GoogleOAuthProvider>
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.FORGOTPASSWORD,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <ForgotPassword />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.ENTEROTP,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <Otp />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: NonAuthRoutes.RESETPASSWORD,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
        <ResetPassword />
      </ThemeProvider>
    ),
  },
  {
    path: AuthRoutes.PATHOLOGY,
    element: <Pathology />,
  },
  {
    path: AuthRoutes.ERRORCODE,
    element: <ErrorCodeList />,
  },
  {
    path: AuthRoutes.MODALITY,
    element: <Modality />,
  },
  {
    path: AuthRoutes.SUBMODALITY,
    element: <SubModality />,
  },
  {
    path: AuthRoutes.ANNOTATION,
    element: <AnnotationList />,
  },
  {
    path: AuthRoutes.ADDANNOTATION,
    element: <AddAnnotation />,
  },
  {
    path: AuthRoutes.VIEWANNOTATION,
    element: <ViewAnnotation />,
  },
  {
    path: AuthRoutes.ADMINUSERLIST,
    element: <AdminUserList />,
  },
  {
    path: AuthRoutes.MYADDADMINUSER,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.ADMIN} />
    ),
  },
  {
    path: AuthRoutes.FIRMADMINUSERLIST,
    element: <FirmAdminUserList />,
  },
  {
    path: AuthRoutes.MYADDFIRMADMINUSER,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.FIRMADMIN} />
    ),
  },
  {
    path: AuthRoutes.MYEDITUSER,
    element: <MyAddUpdateUser action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.MYVIEWUSER,
    element: <MyAddUpdateUser action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.PROVIDERVIEW,
    element: <MyAddUpdateUser action={ACTIONS.VIEW} />,
  },
  {
    path: AuthRoutes.ERRORSTUDY,
    element: <ErrorStudy />,
  },
  {
    path: AuthRoutes.ISSUESANDTROUBLESHOOTING,
    element: <IssuesTroubleShooting />,
  },
  {
    path: AuthRoutes.FIRMLIST,
    element:
      process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
      process.env.REACT_APP_ENTERPRISE_PLATFORM == true ? (
        <HospitalsList />
      ) : (
        <ClientList />
      ),
  },
  {
    path: AuthRoutes.CLIENTLIST,
    element: <ClientList />,
  },
  {
    path: AuthRoutes.FIRMDETAILS,
    // element: <HospitalDetails />
    element: (
      <FirmState>
        <Firm action={ACTIONS.VIEW} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.FIRMDETAILS,
    element: (
      <FirmState>
        <Firm action={ACTIONS.VIEW} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.USERVIEW,
    element: <UserView />,
  },
  {
    path: AuthRoutes.EDITHOSPITAL,
    element: (
      <FirmState>
        <Firm action={ACTIONS.EDIT} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDHOSPITAL,
    element: (
      <FirmState>
        <Firm action={ACTIONS.ADD} firmType={"Hospital"} firmRole={"CLIENT"} />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDTELERADIOLOGYCENTRE,
    element: (
      <FirmState>
        <Firm
          action={ACTIONS.ADD}
          firmType={"Teleradiology Centre"}
          firmRole={"CLIENT"}
        />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.ADDIMAGINGCENTRE,
    element: (
      <FirmState>
        <Firm
          action={ACTIONS.ADD}
          firmType={"Imaging Centre"}
          firmRole={"CLIENT"}
        />
      </FirmState>
    ),
  },
  {
    path: AuthRoutes.SUPERVISORLIST,
    element: <SupervisorList />,
  },
  {
    path: AuthRoutes.MYADDSUPERVISOR,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.SUPERVISOR} />
    ),
  },
  {
    path: AuthRoutes.FIRMDOCTORLIST,
    element: <FirmDoctorList />,
  },
  {
    path: AuthRoutes.MYADDFIRMDOCTOR,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.FIRMDOCTOR} />
    ),
  },
  {
    path: AuthRoutes.FIRMTECHNICIANLIST,
    element: <FirmTechnicianList />,
  },
  {
    path: AuthRoutes.MYADDFIRMTECHNICIAN,
    element: (
      <MyAddUpdateUser
        action={ACTIONS.ADD}
        userType={USERTYPES.FIRMTECHNICIAN}
      />
    ),
  },
  {
    path: AuthRoutes.TYPISTUSERLIST,
    element: <TypistList />,
  },
  {
    path: AuthRoutes.ADDTYPIST,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.TYPIST} />
    ),
  },
  {
    path: AuthRoutes.RADIOLOGISTLIST,
    element:
      process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
      process.env.REACT_APP_ENTERPRISE_PLATFORM == true ? (
        <RadiologistList />
      ) : (
        <ProviderList />
      ),
  },
  {
    path: AuthRoutes.MYADDRADIOLOGIST,
    element: (
      <MyAddUpdateUser action={ACTIONS.ADD} userType={USERTYPES.RADIOLOGIST} />
    ),
  },
  {
    path: AuthRoutes.STUDYLIST,
    element: (
      <StudylistState>
        <StudyReportState>
          <ShareStudyState>
            <StudyList />
          </ShareStudyState>
        </StudyReportState>
      </StudylistState>
    ),
  },
  {
    path: AuthRoutes.ADMINRADIOLOGISTLIST,
    element: <RadiologistList />,
  },
  {
    path: AuthRoutes.HEADERTEMPLATE,
    element: <HeaderTemplate state={{ action: ACTIONS.ADD }} />,
  },
  {
    path: AuthRoutes.EDITHEADERTEMPLATE,
    element: <HeaderTemplate state={{ action: ACTIONS.EDIT }} />,
  },
  {
    path: AuthRoutes.CHANGEPWD,
    element: <ChangePassword />,
  },
  {
    path: AuthRoutes.FORCECHANGEPWD,
    element: <ChangePassword />,
  },
  {
    path: AuthRoutes.UPLOADSTUDY,
    element: (
      <StudylistState>
        <ProgressBarState>
          <UploadStudy />
        </ProgressBarState>
      </StudylistState>
    ),
  },
  // ,
  // {
  //     path: AuthRoutes.STUDYVIEWER + "/:patientID",
  //     element: <StudyviewerState><ThumbnailState><ViewportState><Viewer/></ViewportState></ThumbnailState></StudyviewerState>
  // }
  {
    path: AuthRoutes.STUDYVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AnnotationState>
                <ShareStudyState>
                  <MobileViewerState>
                    <Viewer priors={false} />
                  </MobileViewerState>
                </ShareStudyState>
              </AnnotationState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.PRIORSTUDYVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AnnotationState>
                <ShareStudyState>
                  <MobileViewerState>
                    <Viewer priors={isMobile ? false : true} />
                  </MobileViewerState>
                </ShareStudyState>
              </AnnotationState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.NONXRAYADVANCEVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AnnotationState>
                <ShareStudyState>
                  <MobileViewerState>
                    <AdvanceViewer priors={false} />
                  </MobileViewerState>
                </ShareStudyState>
              </AnnotationState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.REPORTTEMPLATES,
    element: <ReportTemplateListv2 />,
  },
  {
    path: AuthRoutes.MY_STYLES,
    element: (
      <QueryClientProvider client={queryClient}>
        <MyStyles />
      </QueryClientProvider>
    ),
  },
  // {
  //   path: "report/list/template/new/:tabId",
  //   element: <ReportTemplateListv2 />,
  // },
  {
    path: AuthRoutes.ADDREPORTTEMPLATE,
    element: <AddReportTemplate action={ACTIONS.ADD} />,
  },
  {
    path: AuthRoutes.EDITREPORTTEMPLATE,
    element: <AddReportTemplate action={ACTIONS.EDIT} />,
  },
  {
    path: AuthRoutes.EDIT_STYLE,
    element: (
      <QueryClientProvider client={queryClient}>
        <AddStyle action={ACTIONS.EDIT} />
      </QueryClientProvider>
    ),
  },
  {
    path: AuthRoutes.ADD_STYLE,
    element: (
      <QueryClientProvider client={queryClient}>
        <AddStyle action={ACTIONS.ADD} />
      </QueryClientProvider>
    ),
  },
  {
    path: AuthRoutes.ACCOUNTANDSETTINGS,
    element: <ACCOUNTANDSETTINGS />,
  },
  {
    path: AuthRoutes.ANALYTICS,
    element: <Analytics />,
  },
  {
    path: AuthRoutes.SHOW_SHARED_REPORT,
    element: <SharedReport />,
  },
  {
    path: AuthRoutes.ABOUT,
    element: <About />,
  },
  {
    path: NonAuthRoutes.VIEWPDF,
    element: <QRCodeScanReport />,
  },
  {
    path: AuthRoutes.BILLING,
    element: <Billing />,
  },
  {
    path: AuthRoutes.BILLING_DATA_DOWNLOAD_FORM,
    element: <BillingDownloadDataForm />,
  },
  {
    path: AuthRoutes.PING,
    element: <Ping />,
  },
  {
    path: AuthRoutes.PRIVACY_POLICY,
    element: <PrivacyPolicy />,
  },
  {
    path: AuthRoutes.SHAREDVIEWER,
    // path: AuthRoutes.STUDYVIEWER,
    // element: <StudyviewerState><ThumbnailState><ViewportState><StudyReportState><AnnotationState><ShareStudyState><ReportPanel/></ShareStudyState></AnnotationState></StudyReportState></ViewportState></ThumbnailState></StudyviewerState>
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AnnotationState>
                <ShareStudyState>
                  <SharedStudyViewer />
                </ShareStudyState>
              </AnnotationState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
    // element: <StudyviewerState><ThumbnailState><ViewportState><ReportPanel/></ViewportState></ThumbnailState></StudyviewerState>
  },
  {
    path: AuthRoutes.MOBILEMORE,
    element: <MobileMoreOption />,
  },
  {
    path: AuthRoutes.PACSQUEUELIST,
    element: <PacsQueue />,
  },
  {
    path: AuthRoutes.ADVLICENSE,
    element: <AdvLicense />,
  },
  {
    path: AuthRoutes.NOT_ALLOWED,
    element: <NotAuthorized />,
  },
  {
    path: NonAuthRoutes.CONTEXTSWITCHSTUDYLIST,
    element: (
      <StudylistState>
        <StudyReportState>
          <ShareStudyState>
            <StudyList />
          </ShareStudyState>
        </StudyReportState>
      </StudylistState>
    ),
  },
  {
    path: NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER,
    element: (
      <StudyviewerState>
        <ThumbnailState>
          <ViewportState>
            <StudyReportState>
              <AnnotationState>
                <ShareStudyState>
                  <MobileViewerState>
                    <Viewer priors={false} />
                  </MobileViewerState>
                </ShareStudyState>
              </AnnotationState>
            </StudyReportState>
          </ViewportState>
        </ThumbnailState>
      </StudyviewerState>
    ),
  },
  {
    path: AuthRoutes.DOWNLOADTRIGGER,
    element: <DownloadTrigger />,
  },
  {
    path: NonAuthRoutes.TWOFACTORAUTHENTICATION,
    element: (
      <ThemeProvider
        style={isMobile ? mobileStyles : desktopStyles}
        applyTo="body"
        theme={lightTheme}
        className={`app-root light`}
      >
      <TwoFAOtp />{" "}
      </ThemeProvider>
    ),
  },
  {
    path: AuthRoutes.HANGINGPROTOCOLLIST,
    element: <HangingProtocolList />,
  },
  {
    path: AuthRoutes.ADDHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.ADD} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.EDITHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.EDIT} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.VIEWHANGINGPROTOCOL,
    element: (
      <HPState>
        <HPFormManager action={ACTIONS.VIEW} />
      </HPState>
    ),
  },
  {
    path: AuthRoutes.STYLES,
    element: (
      <QueryClientProvider client={queryClient}>
        <MyStyles />
      </QueryClientProvider>
    ),
  }
]);
